import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './BlogList.css';

/* ---  tiny static list (slug must match <Route path="/blog/:slug">)  --- */
const posts = [
  {
    slug: 'A-Blueprint',
    img: 'blog1.jpg',
    title: 'Designing Immersive Experience Centers: A Blueprint for Emotional Impact',
    author: 'Gautam Tewari',
    date: '10 July, 2025',
  },
  {
    slug: 'Boosting-Workplace',
    img: 'blog2.png',
    title: 'Boosting Workplace Performance: Lessons from High-Performance Office Environments',
    author: 'Gautam Tewari',
    date: '28 June, 2025',
  },
  {
    slug: 'Trezi',
    img: 'blog3.jpg',
    title: 'Smartvizx in Action: How Virtual Walkthroughs Revolutionize Design and Delivery',
    author: 'Gautam Tewari',
    date: '25 June, 2025',
  },
  {
    slug: 'Sustainable',
        img: 'blog4.png',
    title: 'Sustainable Design in Experience Centers and Offices: Form Meets Responsibility',
    author: 'Gautam Tewari',
    date: '22 June, 2025',
  },
  {
    slug: 'VR-RealEstate',
    img: '200717-1.jpg',
    title: 'Virtual Reality: Shaping the Future of Real Estate Transactions',
    author: 'SmartVizX Team',
    date: '20 July, 2017',
  },
  {
    slug: 'VR-Buyers-Sellers',
        img: '280617-1.png',

    title: 'Virtual Reality: Bridging the gap between buyers and sellers',
    author: 'SmartVizX Team',
    date: '28 June, 2017',
  },
  {
    slug: 'VR-Design-Build',
    title: 'Virtual Reality Design Software & VR Aided Build',
    author: 'SmartVizX Team',
    date: '30 December, 2016',
  },
  {
    slug: 'ViViz-VR',
    title: 'ViViz VR - Harnessing the power of Mobile Virtual Reality Solutions for business',
    author: 'SmartVizX Team',
    date: '28 December, 2016',
  },
  {
    slug: 'VR-Empowering-Consumers',
    title: 'Virtual Reality Empowering Consumers',
    author: 'SmartVizX Team',
    date: '02 Aug, 2016',
  },
];


export default function BlogList() {
  return (
    <>
      <Navbar />
<div className="blog-list-page-wrapper">
  <video className="backvideo" autoPlay muted loop playsInline>
    <source src="/backvid.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
      <main className="blog-list-wrapper-container">
        {/* HEADER + BLURB */}
        <h1 className="bsection_header text-center">SmartVizX Blog</h1>
        <div className="bsummary box blurb text-center">
          We love to explore and blog about the latest developments in design
          visualisation, architecture and, of course, Virtual Reality. Get the
          best industry insights from the founders and technology team
          @ SmartVizX.
        </div>

        {/* GRID OF CARDS */}
        <div className="bcard-shell">
          {posts.map((p, i) => (
            <div className="bcard" key={i}>
              <Link to={`/blog/${p.slug}`}>
                {/* hero cover (image **or** text excerpt) */}
                {p.img ? (
                  <h3
                    style={{
                      background: `url(/img/blog/${p.img}) no-repeat center / cover`,
                    }}
                  />
                ) : (
                  <h3>{p.excerpt}</h3>
                )}

                <h4>{p.title}</h4>
                <span>
                  {p.author}, {p.date}
                </span>
              </Link>
            </div>
          ))}
        </div>
        
      </main>
        </div>

      <Footer />
    </>
  );
}
